import {Space, Breadcrumb, Row, Col, Divider} from 'antd';
import JobDashboard from "../components/JobDashboard";

export default function PageHome() {
    return (
        <>
            <Row gutter={16}>
                <Col className="gutter-row" span={24}>
                    <Breadcrumb
                        items={[
                            {
                                title: 'Dashboard',
                            },
                        ]}
                    />
                </Col>
            </Row>
            <Divider/>
            <Row gutter={16}>
                <Col className="gutter-row" span={24}>
                    <Space direction="vertical" size="middle" style={{display: 'flex'}}>
                        <JobDashboard/>
                    </Space>
                </Col>
            </Row>
        </>
    );
}